module.exports = __webpack_public_path__ + "static/media/logo-kimflix.7150d8c0.png";